import SettingServerController from './setting.server.controller';

export default {
    controller: SettingServerController,
    template: require('./setting.server.tpl.html')
};
